export default {
  priv: 'manage',
  overviewTitle: 'ProcessStates',
  detailTitle: 'ProcessState',
  deleteTitle: 'dit ProcessState',
  url: '/manage/processstates',
  apiUrl: '/processstates/',
  sortBy: ['name'],
  sortDesc: [false],
  deletable: true,
  editable: true,
  filterName: 'manage/processstates',
  quickFilter: {
    text: 'Zoek op name',
    value: 'name',
    type: 'text'
  },
  newRecord: {
  },
  // isReadOnlyOverview: true,
  // customEditable(context, item) {
  //   return false;
  // },
  // customDeletable(context, item) {
  //   return false;
  // },
  tableFields: [
    {text: 'Name', value: 'name', link: '/manage/processstates/{id}', width: '10%'},
    {text: 'Name_Nl', value: 'name_nl', width: '10%'}
  ]
};
